// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function AlertTitle (theme) {
	return {
		MuiAlertTitle: {
			styleOverrides: {
				root: {
					// marginBottom: 4,
					// marginTop: 0,
					// fontWeight: 400
				}
			}
		}
	}
}